
const namespaced = true;

const state = {
  tags: [],
};

const mutations = {
  SET_TAGS(state, tags) {
    state.tags = tags;
  },
};

const actions = {
  async fetchClientTags({ commit, dispatch }, clientId) {
    commit(`SET_TAGS`, []);

    const tags = await dispatch(`model/tag/fetchForClient`, clientId, { root: true });

    commit(`SET_TAGS`, tags);
  },
  async fetchMakerTags({ commit, dispatch }, makerId) {
    commit(`SET_TAGS`, []);

    const tags = await dispatch(`model/tag/fetchForMaker`, makerId, { root: true });

    commit(`SET_TAGS`, tags);
  },
};

const getters = {};

export default {
  namespaced, state, mutations, actions, getters,
};
